export const SET_DATA = "@USERS_CONNECTIONS/SET_DATA";
export const SET_FORMATTED = "@USERS_CONNECTIONS/SET_FORMATTED";
export const READ = "@USERS_CONNECTIONS/READ";
export const READ_FAIL = "@USERS_CONNECTIONSREAD_FAIL";
export const READ_SUCCESS = "@USERS_CONNECTIONS/READ_SUCCESS";
export const REQUEST_READ = "@USERS_CONNECTIONS/REQUEST_READ";
export const DELETE = '@USERS_CONNECTIONS/DELETE';
export const DELETE_FAIL = '@USERS_CONNECTIONS/DELETE_FAIL';
export const DELETE_SUCCESS = '@USERS_CONNECTIONS/DELETE_SUCCESS';
export const REQUEST_DELETE = '@USERS_CONNECTIONS/REQUEST_DELETE';